export default {
  root: {
    borderRadius: '9px',
    outline: '5px solid #707070'
  }
}
